export default {
  title: {
    id: 'services_hub_insurance_title',
    defaultMessage: 'Protection Plans',
  },
}
